<template>
    <div class="footer-results">
        <div class="footer-container">
            <a href="https://3rdurable.org/" target="_blank"><img :src="iconTRDurable" class="icon-tr-durable"/></a>
            <div class="footer-text">
                <h3>Vous avez des questions? </h3>
                <p class="paragraph">
                    N’hésitez pas à contacter l’équipe de la Fondation Trois-Rivières durable pour vous aider: <a href="mailto:eclore@3Rdurable.org">eclore@3Rdurable.org</a> 
                </p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            iconTRDurable:require('@/assets/images/logo_tr_durable.png'),
        }
    }
}
</script>
<style scoped>
.footer-results {
    background-color: white;
    width: 100%;
}

.footer-container {
    display: flex;
    align-items: center;
    flex-wrap:wrap;
    width: 50%;
    margin-left: 10%;
    margin-right: auto;
}
.footer-text{
    max-width:calc(100% - 250px);
}
.icon-tr-durable{
    height:109px;
}
.footer-results h3{
    color: #00B5C6;
    /* DESKTOP/H4 */
    font-family: var(--font);
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 33.2px; 
    margin-bottom: 0;
}

@media screen and (max-width: 1520px) {
    .footer-container{
        width:80%;
    }
    
}
@media (max-width: 992px) {
    .footer-results h3{
        font-size: 25px;
    }
}

@media (max-width: 768px) {
 
}
@media screen and (max-width: 600px) {
    .icon-tr-durable{
        min-width:60%;
        width:60%;
        height:auto;
    }
    .footer-text{
        max-width:100%;
    }
    .footer-container{
        width:80%;
    }
    .footer-results h3{
        font-size: 1.7rem;
        margin-top: 0;
    }
}
</style>